import api from "../apis/api";

class SurveyService {
    putRating(req) {
        return api.survey.putRating(req);
    }

    putComment(req) {
        return api.survey.putComment(req);
    }
}

export default new SurveyService();
